export default __webpack_public_path__ + "static/media/Ring-Placeholder.6c3c6d87.png";